import { z } from "zod";

import { assetSchema } from "../commons/asset";

export const createBodySchema = z.object({
  skills: z.array(z.string()).nonempty(),
  tools: z.array(z.string()).nonempty(),
  industry: z.string().nonempty(),
  company: z.string().nonempty(),
  description: z.string().nonempty(),
  title: z.string().nonempty(),
  year: z.coerce.number(),
  role: z.string().nonempty(),
  assets: z.array(assetSchema).nonempty(),
});

export type CreateBody = z.infer<typeof createBodySchema>;

export const createRequestSchema = z.object({
  body: createBodySchema,
});

export type CreateRequest = z.infer<typeof createRequestSchema>;

export const updateBodySchema = z.object({
  skills: z.array(z.string()).nonempty(),
  tools: z.array(z.string()).optional(),
  industry: z.string().nonempty(),
  company: z.string().nonempty(),
  description: z.string().nonempty(),
  title: z.string().nonempty(),
  year: z.coerce.number(),
  role: z.string().nonempty(),
  assets: z.array(assetSchema).nonempty(),
});

export const updateParamsSchema = z.object({
  highlightId: z.string().nonempty(),
});

export const updateRequestSchema = z.object({
  body: updateBodySchema,
  params: updateParamsSchema,
});

export type UpdateRequest = z.infer<typeof updateRequestSchema>;

export const detailHighlightParamsSchema = z.object({
  highlightId: z.string().nonempty(),
});

export const detailHighlightRequestSchema = z.object({
  params: detailHighlightParamsSchema,
});

export type DetailHighlightRequest = z.infer<
  typeof detailHighlightRequestSchema
>;

export const getResponseSchema = z.array(
  z.object({
    _id: z.string(),
    title: z.string(),
    hero: z.string().nullable(),
  }),
);

export type GetResponse = z.infer<typeof getResponseSchema>;
